import { HomePageSecondarySlide, ValuePropSlide } from '../shared/interface'

const carouselSlideProductClickedProperties = {
  price: {},
  name: 'homepage cta carousel item',
  product_id: '-1',
}

const shopbyStylesBaseAnalyticsProperties = {
  ...carouselSlideProductClickedProperties,
  list_id: 'shop-designs-by-style',
}

const shopbyCategoriesBaseAnalyticsProperties = {
  ...carouselSlideProductClickedProperties,
  list_id: 'shop-by-category',
}

const trendingDesignBaseAnalyticsProperties = {
  list_id: 'trending-designs',
}

export const isInRange = (banner: HomePageSecondarySlide): boolean =>
  !banner.startDate ||
  !banner.endDate ||
  (banner.startDate <= new Date().toISOString() && banner.endDate > new Date().toISOString())

const ValuePropSlideData: ValuePropSlide[] = [
  {
    heading: 'Free Design Assistance',
    link: {
      title: 'Start Personalizing',
      url: '/invitations/wedding',
    },
    body: 'From updating fonts to custom colors, we can help bring your vision to life.',
    image: 'https://media-api.xogrp.com/images/bb958079-bae6-4873-95c4-4cc5292cbd90',
  },
  {
    heading: 'Matching Websites',
    link: {
      title: 'Find Your Match',
      url: 'https://www.theknot.com/gs/wedding-websites?vers=0',
    },
    body: 'Coordinate your paper with a free wedding website to stay on theme.',
    image: 'https://media-api.xogrp.com/images/08012b1d-1f1b-45ba-8b94-4847ac4b1b18',
  },
  {
    heading: 'Easy Guest Addressing',
    link: { title: 'Get Started', url: '/invitations/wedding' },
    body: 'Save time and let us address your envelopes in any design you choose.',
    image: 'https://media-api.xogrp.com/images/72f0aedc-9bb2-48be-880e-947a16f95280',
  },
]

const TrendingDesignsData: HomePageSecondarySlide[] = [
  {
    name: 'Eucalyptus Frame Wedding Invitations',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//0826k/win/image-files/color-theme_wht/front/eucalyptus-frame-wedding-invitations.jpg',
    url: '/product/eucalyptus-frame-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: 'paper/product/eucalyptus-frame-wedding-invitations',
        price: 1.99,
        name: 'Eucalyptus Frame Wedding Invitations',
        product_id: '10oYGRsE21A2oocnezyVIF"',
        category: 'Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//0826k/win/image-files/color-theme_wht/hero/eucalyptus-frame-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: '500d90d2-5d4e-4b3c-8d26-f0b04dddf419',
        variant: {
          color: 'White',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Nothing Fancy All-in-One Wedding Invitations',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//325k/aio/image-files/color-theme_wht/front/nothing-fancy-all-in-one-wedding-invitations.jpg',
    url: '/product/nothing-fancy-all-in-one-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/nothing-fancy-all-in-one-wedding-invitations',
        price: 1.79,
        name: 'Nothing Fancy All-in-One Wedding Invitations',
        product_id: '2WI4POzpdHfcCssPGRea7e',
        category: 'All-in-One Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//325k/aio/image-files/color-theme_wht/hero/nothing-fancy-all-in-one-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: 'afe7f38d-4c2a-4398-bcbb-cd899ff04b4d',
        variant: {
          color: 'White',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'All-in-One',
          material: 'Signature Light',
          paper_color: 'No Paper Color',
          printing_options: 'Both Recipient and Return Addresses',
        },
      },
    },
  },
  {
    name: 'Glamorous Crown Monogram Crest Wedding Invitations by Bridgerton',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//835k/win/image-files/foil-theme_fgld/color-theme_grn/front/glamorous-crown-monogram-crest-wedding-invitations.jpg',
    url: '/product/glamorous-crown-monogram-crest-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/glamorous-crown-monogram-crest-wedding-invitations',
        price: 2.59,
        name: 'Glamorous Crown Monogram Crest Wedding Invitations by Bridgerton',
        product_id: '4NgmePj3WiXJ6BxftrwvDc',
        category: 'Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//835k/win/image-files/foil-theme_fgld/color-theme_grn/hero/glamorous-crown-monogram-crest-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: 'b2174323-dc35-4179-a029-7a9dd51e0507',
        variant: {
          color: 'Green',
          flap_type: 'No Flap Type',
          foil_color: 'Gold',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Our Date Save the Date Cards',
    image: 'https://media-api.xogrp.com/images/f06eee20-5853-4260-9f91-af08388c3de4',
    url: '/product/our-date-save-the-date-cards',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/our-date-save-the-date-cards',
        name: 'Our Date Save the Date Cards',
        category: 'Save the Date Cards',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//786k/sdc/image-files/color-theme_grn/hero/our-date-save-the-date-cards.jpg',
        price: 1.29,
        product_id: '2MLURjD1HsN23oarkbRj8t',
        quantity: 100,
        sample: false,
        sku: 'https://media-api.xogrp.com/images/f06eee20-5853-4260-9f91-af08388c3de4',
        variant: {
          color: 'Green',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Beloved Floral Wedding Invitations',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//0691k/win/image-files/color-theme_red/front/beloved-floral-wedding-invitations.jpg',
    url: '/product/beloved-floral-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: 'paper/product/beloved-floral-wedding-invitations',
        price: 1.99,
        name: 'Beloved Floral Wedding Invitations',
        product_id: '7gpOcCi2H76hTVjKaaboHm',
        category: 'Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//0691k/win/image-files/color-theme_red/hero/beloved-floral-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: '014e1541-5298-426f-b658-e5e9a52b06e0',
        variant: {
          color: 'Red',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Opulences Wedding Invitations by Vera Wang',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//1177k/win/image-files/foil-theme_fgld/color-theme_wht/front/opulences-vera-wang-wedding-invitations.jpg',
    url: '/product/opulences-vera-wang-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/opulences-vera-wang-wedding-invitations',
        name: 'Opulences Wedding Invitations by Vera Wang',
        category: 'Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//1177k/win/image-files/foil-theme_fgld/color-theme_wht/hero/opulences-vera-wang-wedding-invitations.jpg',
        price: 3.09,
        product_id: '4cQQ89pRuf0SOelIRCQoc3',
        quantity: 100,
        sample: false,
        sku: 'a282188e-af08-438f-b554-e5cba079acfe',
        variant: {
          color: 'White',
          flap_type: 'No Flap Type',
          foil_color: 'Gold',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Vintage Film All-in-One Wedding Invitations',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//172k/aio/image-files/color-theme_crm/front/vintage-film-all-in-one-wedding-invitations.jpg',
    url: '/product/vintage-film-all-in-one-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: 'paper/product/vintage-film-all-in-one-wedding-invitations',
        price: 1.79,
        name: 'Vintage Film All-in-One Wedding Invitations',
        product_id: '79WC4GBMQHNnL3ibkWSBot',
        category: 'All-in-One Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//172k/aio/image-files/color-theme_crm/hero/vintage-film-all-in-one-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: 'f0aa315a-c285-40e3-8c8e-c8b27ba030ff',
        variant: {
          color: 'Cream',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'All-in-One',
          material: 'Signature Light',
          paper_color: 'No Paper Color',
          printing_options: 'Both Recipient and Return Addresses',
        },
      },
    },
  },
  {
    name: 'Vintage Nouveau Wedding Invitations',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//1051k/win/image-files/color-theme_grn/front/vintage-nouveau-wedding-invitations.jpg',
    url: '/product/vintage-nouveau-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/vintage-nouveau-wedding-invitations',
        price: 1.99,
        name: 'Vintage Nouveau Wedding Invitations',
        product_id: '1KnPuIwpRdoAs4QC4EJPP6',
        category: 'Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//1051k/win/image-files/color-theme_grn/hero/vintage-nouveau-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: '1ab8c09e-ded6-4ab6-8a10-83b1c8451549',
        variant: {
          color: 'Green',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Simple Modern Wildflowers Wedding Invitations',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//995k/win/image-files/color-theme_org/front/simple-modern-wildflowers-wedding-invitations.jpg',
    url: '/product/simple-modern-wildflowers-wedding-invitations',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/simple-modern-wildflowers-wedding-invitations',
        price: 1.99,
        name: 'Simple Modern Wildflowers Wedding Invitations',
        product_id: '6UG684TCgL1GOVwwejiScA',
        category: 'Wedding Invitations',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//995k/win/image-files/color-theme_org/hero/simple-modern-wildflowers-wedding-invitations.jpg',
        sample: false,
        quantity: 100,
        sku: 'f91f8d5d-284d-4cb4-9ee5-73f97a633987',
        variant: {
          color: 'Orange',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
  {
    name: 'Corner Script Save The Date Cards',
    image:
      'https://media-api.xogrp.com/images/fetch/https://tkww-paper-designs.s3.amazonaws.com/master//1413k/sdc/image-files/color-theme_blk/front/corner-script-save-the-date-cards.jpg',
    url: '/product/corner-script-save-the-date-cards',
    tracking: {
      clicked: {
        ...trendingDesignBaseAnalyticsProperties,
        url: '/paper/product/corner-script-save-the-date-cards',
        price: 1.29,
        name: 'Corner Script Save The Date Cards',
        product_id: '2droJO3gRR6Nr4NFQNIybJ',
        category: 'Save the Date Cards',
        image_url:
          'https://tkww-paper-designs.s3.amazonaws.com/master//1413k/sdc/image-files/color-theme_blk/hero/corner-script-save-the-date-cards.jpg',
        sample: false,
        quantity: 100,
        sku: '62852e53-d6cc-42bc-85e0-eebc9e2a0ed1',
        variant: {
          color: 'Black',
          flap_type: 'No Flap Type',
          foil_color: 'No Foil',
          format: 'Standard',
          material: 'Signature',
          paper_color: 'No Paper Color',
          printing_options: 'No Printing Options',
        },
      },
    },
  },
]

const CategoriesData: HomePageSecondarySlide[] = [
  {
    name: 'Save The Dates',
    image: 'https://media-api.xogrp.com/images/553f66fe-2ca8-4a30-8803-56733b8a07f4',
    url: '/save-the-dates/save-the-date-cards',
    tracking: {
      clicked: {
        ...shopbyCategoriesBaseAnalyticsProperties,
        category: ['Save The Dates'],
        url: '/paper/save-the-dates/save-the-date-cards',
      },
    },
  },
  {
    name: 'Invitations',
    image: 'https://media-api.xogrp.com/images/bb015b0f-6825-4d75-9b76-bde6d528ac7d',
    url: '/invitations/wedding',
    tracking: {
      clicked: {
        ...shopbyCategoriesBaseAnalyticsProperties,
        category: ['Invitations'],
        url: '/paper/invitations/wedding',
      },
    },
  },

  {
    name: 'Ceremony & Reception',
    image: 'https://media-api.xogrp.com/images/7c689fb6-7f98-4ac8-be51-8ada1f12b84f',
    url: '/ceremony-reception',
    tracking: {
      clicked: {
        ...shopbyCategoriesBaseAnalyticsProperties,
        category: ['Ceremony & Reception'],
        url: '/paper/ceremony-reception',
      },
    },
  },

  {
    name: 'Thank Yous',
    image: 'https://media-api.xogrp.com/images/9d9a5ae4-a21d-4828-8a6d-157ec10843e5',
    url: '/thank-yous',
    tracking: {
      clicked: {
        ...shopbyCategoriesBaseAnalyticsProperties,
        category: ['Thank Yous'],
        url: '/paper/thank-yous',
      },
    },
  },

  {
    startDate: process.env.APP_HOLIDAY_CARDS_HOMEPAGE_PROMO_START_DATETIME_ISO || '2023-09-26T08:00:00.000Z',
    endDate: process.env.APP_HOLIDAY_CARDS_HOMEPAGE_PROMO_END_DATETIME_ISO || '2024-01-31T08:00:00.000Z',
    name: 'Holiday Cards',
    image: 'https://media-api.xogrp.com/images/c332ffe5-6410-45c9-b136-be2fda8ecb17',
    url: '/holiday-cards',
    tracking: {
      clicked: {
        ...shopbyCategoriesBaseAnalyticsProperties,
        category: ['Holiday Cards'],
        url: '/paper/holiday-cards',
      },
    },
  },
]

const StyleData: HomePageSecondarySlide[] = [
  {
    name: 'Floral',
    image: 'https://media-api.xogrp.com/images/b8f777e0-d5a4-49d0-a82e-16cdd8aa001e',
    url: '/invitations?styles=Floral',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Floral',
        category: ['Floral'],
      },
    },
  },
  {
    name: 'Classic',
    image: 'https://media-api.xogrp.com/images/97275beb-c1da-490f-a369-d33622743369',
    url: '/invitations?styles=Classic',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Classic',
        category: ['Classic'],
      },
    },
  },
  {
    name: 'Rustic',
    image: 'https://media-api.xogrp.com/images/a232d674-97aa-41d9-941e-a1d2543a3849',
    url: '/invitations?styles=Rustic',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Rustic',
        category: ['Rustic'],
      },
    },
  },
  {
    name: 'Vintage',
    image: 'https://media-api.xogrp.com/images/aa5a6086-9e8d-4f8d-ab01-609bb58dbcab',
    url: '/invitations?styles=Vintage',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Vintage',
        category: ['Vintage'],
      },
    },
  },
  {
    name: 'Simple',
    image: 'https://media-api.xogrp.com/images/4736f1ea-307a-44e0-a8f4-8cc29da6f182',
    url: '/invitations?styles=Simple',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Simple',
        category: ['Simple'],
      },
    },
  },
  {
    name: 'Modern',
    image: 'https://media-api.xogrp.com/images/8da03a59-b9e5-45e9-9f8c-92bdba59c1bb',
    url: '/invitations?styles=Modern',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Modern',
        category: ['Modern'],
      },
    },
  },
  {
    name: 'Destination',
    image: 'https://media-api.xogrp.com/images/f33de453-c312-4f19-8895-6820ec08691b',
    url: '/invitations?styles=Destination',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Destination',
        category: ['Destination'],
      },
    },
  },
  {
    name: 'Bohemian',
    image: 'https://media-api.xogrp.com/images/cb0d3ba3-9fa0-4500-ac17-96d39e164e3a',
    url: '/invitations?styles=Bohemian',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Bohemian',
        category: ['Bohemian'],
      },
    },
  },
  {
    name: 'Funny',
    image: 'https://media-api.xogrp.com/images/00d023d5-b53f-4525-a6e2-82c0036f533c',
    url: '/invitations?styles=Funny',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Funny',
        category: ['Funny'],
      },
    },
  },
  {
    name: 'Beach',
    image: 'https://media-api.xogrp.com/images/b74c9a9f-62db-420c-b773-0a98fa35cc77',
    url: '/invitations?styles=Beach',
    tracking: {
      clicked: {
        ...shopbyStylesBaseAnalyticsProperties,
        url: '/paper/invitations?styles=Beach',
        category: ['Beach'],
      },
    },
  },
]

export const HomePageData = {
  trendingDesigns: TrendingDesignsData.filter(isInRange),
  categories: CategoriesData.filter(isInRange),
  styles: StyleData,
  valuePropData: ValuePropSlideData,
}
